<template>
  <generic-modal
    size
    :title="$t('database')"
    icon="database"
    image="/images/icons/database_1.png"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <div class="three fields">
          <div class="field">
            <label for>{{ $t("engine") }}</label>
            <div class="ui selection dropdown" ref="engine_dropdown">
              <input type="hidden" name="engine" />
              <i class="dropdown icon"></i>
              <div class="default text"></div>
              <div class="menu">
                <div class="item" data-value="mysql">
                  <i class="database icon"></i>
                  {{ $t("mysql") }}
                </div>
                <div class="item" data-value="oracle">
                  <i class="database icon"></i>
                  {{ $t("oracle") }}
                </div>
                <div class="item" data-value="mssql">
                  <i class="microsoft icon"></i>
                  {{ $t("sql server") }}
                </div>
              </div>
            </div>
          </div>
          <div class="field">
            <label for>{{ $t("host") }}</label>
            <input type="text" name="host" v-model="setup.host" />
          </div>
          <div class="field">
            <label for>{{ $t("port") }}</label>
            <input type="text" name="port" v-model="setup.port" />
          </div>
        </div>
        <div class="three fields">
          <div class="field">
            <label for>{{ $t("database") }}</label>
            <input type="text" name="database" v-model="setup.database" />
          </div>
          <div class="field">
            <label for>{{ $t("username") }}</label>
            <input type="text" name="username" v-model="setup.username" />
          </div>
          <div class="field">
            <label for>{{ $t("password") }}</label>
            <input type="password" name="password" v-model="setup.password" />
          </div>
        </div>
        <div class="ui error message"></div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api } from "@/utils";
import GenericModal from "@/components/GenericModal";

export default {
  components: {
    "generic-modal": GenericModal
  },
  computed: {},
  props: { database: Object },
  data() {
    return {
      uuid: undefined,
      setup: {
        engine: "",
        host: "",
        port: "",
        database: "",
        username: "",
        password: "",
        form: undefined
      }
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let isValid = vm.form.form("validate form");

        if (!isValid) reject();
        else {
          let req = vm.setup;
          req.u = vm.uuid;
          local_api(vm, "post", "/ngine_core/database/do-save", req)
            .then(database => {
              vm.$emit("succedded", database);
              resolve();
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    destroy() {
      this.$emit("destroy");
    }
  },
  mounted() {
    let vm = this;

    vm.form = window.jQuery(vm.$refs.form).form({
      fields: {
        engine: ["empty"],
        host: ["empty"],
        port: ["empty", "number"],
        database: ["empty"],
        username: ["empty"],
        password: ["empty"]
      }
    });

    window.jQuery(vm.$refs.engine_dropdown).dropdown({
      onChange: function(value) {
        vm.setup.engine = value;
      }
    });

    if (vm.database) {
      vm.form.form("set values", vm.database.setup);
      vm.setup = vm.database.setup;
      vm.uuid = vm.database.uuid;
    }
  },
  watch: {},
  updated: function() {}
};
</script>
